// A seat gets padded with a placeholder mate id (see gameInRoom.ts's
// resolveSeating) when bgio needs at least 2 players but fewer real mates
// are actually present — e.g. a game that supports solo play. Games that
// want to know "is anyone actually behind this seat" (rather than reaching
// into room internals to parse mate ids themselves) can derive that from
// `setupData.placeholderSeatIndexes`, which both the server (gameInRoom.ts,
// for a bgio-plugin game) and the client (apps/web's roomConnection.ts, for
// an action-relayed game) compute via this same helper before calling
// bgio's InitializeGame.
export const PLACEHOLDER_MATE_ID_SUFFIX = '_placeholder'

export function isPlaceholderMateId(mateId: string): boolean {
  return mateId.endsWith(PLACEHOLDER_MATE_ID_SUFFIX)
}

export function derivePlaceholderSeatIndexes(mateIDs: string[]): number[] {
  return mateIDs.reduce<number[]>((indexes, mateId, index) => {
    if (isPlaceholderMateId(mateId)) indexes.push(index)
    return indexes
  }, [])
}
